/* VINOD — sold-out traffic beacon
   ---------------------------------------------------------------------------
   Feeds the Missed opportunity report in the stock-alert app. Three events,
   sent to POST <endpoint>/track:

     view        a sold-out product page was viewed
     form_seen   the notify button scrolled into the viewport
     form_start  the shopper opened the alert form

   It reads the SKU straight off the [data-vbis-open] trigger the back-in-stock
   snippet already renders, so there is nothing to configure per product and no
   Liquid to edit. If the product is in stock the trigger does not exist and
   this file does nothing.

   Privacy: no email, no IP, no cookie, and nothing identifying is ever sent.
   Whether this is the browser's first view of the product today is worked out
   here and sent as a plain true/false, so the report can say "82 visits from 71
   visitors" without the app ever knowing who they were.
   --------------------------------------------------------------------------- */
(function () {
  if (window.__vdTrackLoaded) return;
  window.__vdTrackLoaded = true;

  var DEFAULT_ENDPOINT = 'https://vinod-stock-alert.web-a2a.workers.dev';
  var ENDPOINT = (window.VINOD_BIS_ENDPOINT || DEFAULT_ENDPOINT).replace(/\/+$/, '') + '/track';
  var SEEN_KEY = 'vinod:seen';

  // Product pages only. A sold-out button injected into a collection grid is
  // not a product-page visit and would inflate every figure on the report.
  if (location.pathname.indexOf('/products/') === -1) return;

  var today = new Date().toISOString().slice(0, 10);

  /* First view of this product today, from this browser? Kept as one small
     object of sku -> date in localStorage, pruned to today on every load. */
  function firstToday(sku) {
    try {
      var seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {};
      Object.keys(seen).forEach(function (k) {
        if (seen[k] !== today) delete seen[k];
      });
      if (seen[sku] === today) {
        localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
        return false;
      }
      seen[sku] = today;
      localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
      return true;
    } catch (e) {
      // Storage blocked (private browsing): treat every visit as its own.
      return true;
    }
  }

  var sent = {};

  function send(ev, sku, product, unique) {
    if (!sku) return;
    var once = ev + '|' + sku;
    if (ev !== 'view' && sent[once]) return;
    sent[once] = true;

    var body = JSON.stringify({
      ev: ev,
      sku: sku,
      product: product || '',
      unique: unique === true
    });

    try {
      // text/plain keeps this a simple request, so there is no CORS preflight
      // and the browser will still deliver it while the page is unloading.
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
        return;
      }
    } catch (e) { /* fall through to fetch */ }

    try {
      fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'cors' });
    } catch (e) { /* a lost beacon is not worth an error in the console */ }
  }

  function trigger() {
    return document.querySelector('[data-vbis-open]');
  }

  function skuOf(el) {
    return el && el.dataset ? el.dataset.vbisSku || '' : '';
  }

  function titleOf(el) {
    return el && el.dataset ? el.dataset.vbisProductTitle || '' : '';
  }

  var lastView = '';

  function pageView() {
    var el = trigger();
    var sku = skuOf(el);
    if (!sku || sku === lastView) return;
    lastView = sku;
    send('view', sku, titleOf(el), firstToday(sku));
    watchVisibility(el);
  }

  var io = null;

  function watchVisibility(el) {
    if (!el || !window.IntersectionObserver) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          send('form_seen', skuOf(entry.target), titleOf(entry.target));
          io.unobserve(entry.target);
        });
      }, { threshold: 0.5 });
    }
    io.observe(el);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-vbis-open]') : null;
    if (!btn) return;
    send('form_start', skuOf(btn), titleOf(btn));
  }, true);

  /* The theme swaps the trigger when the shopper picks another variant, and the
     back-in-stock script injects it on some templates after load — so watch for
     it rather than reading the DOM once. */
  var timer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(pageView, 250);
  });

  function start() {
    pageView();
    mo.observe(document.body, { childList: true, subtree: true, attributeFilter: ['data-vbis-sku'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
